export default __webpack_public_path__ + "static/media/step-2-inactive.19c9c786.svg";